/* eslint-disable max-len */
import React from 'react'
import { RouteObject } from 'react-router-dom'
import { SocietyHome } from '../../../views/society/SocietyHome'
import { ResidentListView } from '../../../views/society/Resident/ResidentListView'
import { BinderView } from '../../../views/society/Resident/BinderView'
import { MarketplaceListView } from '../../../views/society/Marketplace/MarketplaceListView'
import { BoardListView } from '../../../views/society/Resident/BoardListView'
import { ContactsView } from '../../../views/society/Resident/ContactsView'
import { FindFriendsView } from '../../../views/society/Resident/FindFriendsView'
import { QuestionsAndAnswersView } from '../../../views/society/Resident/QuestionsAndAnswersView'
import { HouseRulesView } from '../../../views/society/Resident/HouseRulesView'
import { CalendarView } from '../../../views/society/Resident/CalendarView'
import { FacilitiesView } from '../../../views/society/Resident/FacilitiesView'
import { useSocietyManagementRoutes } from './useSocietyManagementRoutes'
import { SocietyManagementRoot } from '../../../views/society/SocietyManagementRoot'
import { DocumentsView } from '../../../views/society/Resident/DocumentsView'
import { WidgetView } from '../../../views/society/Resident/WidgetView'
import { LocalOffersView } from '../../../views/society/Resident/LocalOffersView'
import { LocalOfferView } from '../../../views/society/Resident/LocalOfferView'
import { ReportProblemView } from '../../../views/society/Resident/ReportProblemView'
import { TicketCreateView } from '../../../views/society/Resident/Ticket/TicketCreateView/TicketCreateView'
import { TicketDetailView } from '../../../views/society/Resident/Ticket/TicketDetailView'
import { SocietyResidentTicketLayout } from '../../../views/society/Resident/Ticket/TicketLayout'
import { OnboardingView } from '../../../views/society/Onboarding/OnboardingView'
import { CreateUpdateFacilityView } from '../../../views/society/Resident/CreateUpdateFacilityView'
import { FacilityView } from '../../../views/society/Resident/FacilityView'
import { MarketplaceDetailView } from '../../../views/society/Marketplace/MarketplaceDetailView'
import { SocietyRoot } from '../../../views/society/SocietyRoot'
import { EventDetailView } from '../../../views/society/EventDetailView'
import { UnitPickerView } from '../../../views/society/Resident/UnitPickerView'
import { SocietyLayout } from '../../../views/society/SocietyLayout'
import { SocietySideBarContent } from '../../../components/society/SocietySideBarContent'
import { SocietyManagementTicketLayout } from '../../../views/society/Management/Ticket/TicketLayout'
import { TicketBoardCreateView } from '../../../views/society/Management/Ticket/TicketBoardCreateView/TicketBoardCreateView'
import { TicketDetailViewBoard } from '../../../views/society/Management/Ticket/TicketBoardDetailView/TicketBoardDetailView'

const useSocietyRoutes = (): RouteObject[] => {
  const societyManagementRoutes = useSocietyManagementRoutes()

  return [
    {
      path: ':id',
      element: <SocietyRoot />,
      children: [
        {
          element: <SocietyLayout sidebar={<SocietySideBarContent />} />,
          children: [
            {
              path: 'home',
              element: <SocietyHome />,
            },
            {
              path: 'onboarding',
              element: <OnboardingView />,
            },
            {
              path: 'management',
              element: <SocietyManagementRoot />,
              children: societyManagementRoutes,
            },
            {
              path: 'resident/neighborhood/marketplace',
              element: <MarketplaceListView />,
            },
            {
              path: 'resident/neighborhood/:marketplace/:resourceId',
              element: <MarketplaceDetailView />,
            },
            {
              path: 'resident/neighborhood/find-friends',
              element: <FindFriendsView />,
            },
            {
              path: 'resident/functions/binder',
              element: <UnitPickerView />,
            },
            {
              path: 'resident/functions/binder/:unitId/:folderId',
              element: <BinderView />,
            },
            {
              path: 'resident/functions/binder/:unitId',
              element: <BinderView />,
            },
            {
              path: 'resident/functions/resident-list',
              element: <ResidentListView />,
            },
            {
              path: 'resident/functions/board',
              element: <BoardListView />,
            },
            {
              path: 'resident/functions/contacts',
              element: <ContactsView />,
            },
            {
              path: 'resident/functions/calendar',
              element: <CalendarView />,
            },
            {
              path: 'resident/functions/calendar/:eventId/*',
              element: <EventDetailView />,
            },
            {
              path: 'resident/functions/documents',
              element: <DocumentsView />,
            },
            {
              path: 'resident/functions/documents/:documentId',
              element: <DocumentsView />,
            },
            {
              path: 'resident/functions/facilities',
              element: <FacilitiesView />,
            },
            {
              path: 'resident/functions/facilities/create',
              element: <CreateUpdateFacilityView />,
            },
            {
              path: 'resident/functions/facilities/:facilityId/update',
              element: <CreateUpdateFacilityView />,
            },
            {
              path: 'resident/functions/facilities/:facilityId/*',
              element: <FacilityView />,
            },
            {
              path: 'resident/functions/questions-and-answers',
              element: <QuestionsAndAnswersView />,
            },
            {
              path: 'resident/functions/house-rules',
              element: <HouseRulesView />,
            },
            {
              path: 'resident/functions/local-offers',
              element: <LocalOffersView />,
            },
            {
              path: 'resident/functions/local-offers/:offerId',
              element: <LocalOfferView />,
            },
            {
              path: 'resident/functions/report-problem',
              element: <ReportProblemView />,
            },
            {
              path: 'resident/functions/widgets/:widgetId',
              element: <WidgetView />,
            },
          ],
        },
        {
          element: <SocietyResidentTicketLayout />,
          children: [
            {
              path: 'resident/functions/ticket',
              children: [
                {
                  index: true,
                  element: <TicketCreateView />,
                },
                {
                  path: 'create',
                  element: <TicketCreateView />,
                },
                {
                  path: ':ticketId',
                  element: <TicketDetailView />,
                },
              ],
            },
          ],
        },
        {
          element: <SocietyManagementRoot />,
          children: [
            {
              path: 'management/board/tickets',
              element: <SocietyManagementTicketLayout />,
              children: [
                {
                  index: true,
                  element: <TicketBoardCreateView />,
                },
                {
                  path: 'create',
                  element: <TicketBoardCreateView />,
                },
                {
                  path: ':ticketId',
                  element: <TicketDetailViewBoard />,
                },
              ],
            },
          ],
        },
      ],
    },
  ]
}

useSocietyRoutes.displayName = 'useSocietyRoutes'
export { useSocietyRoutes }
